import { Box, Typography } from "@mui/material";
import React from "react";
import UserListIcon from "@assets/icons/userListIcon";

interface UserListHeaderProps {
  totalUserCount: number;
}

const UserListHeader: React.FC<UserListHeaderProps> = ({ totalUserCount }) => {
  return (
    <Box className="flex flex-row items-center">
      <Typography className="md:p-2 py-3 px-1">
        <UserListIcon />
      </Typography>
      <Typography className="flex items-center text-[#090909]" sx={{fontSize:'16px', fontWeight:600}}>
        Users {"(" + totalUserCount + ")"}
      </Typography>
    </Box>
  );
};

export default UserListHeader;
